(() => {
  const node = document.getElementById('papiro-native-modules');
  if (!node || window.__papiroNativeModules) return;
  window.__papiroNativeModules = true;
  const entries = JSON.parse(node.textContent), pending = new Map();
  const watched = entries.map(entry => entry[0]).join(',');
  const load = (selector, url) => {
    if (pending.has(url) || !document.querySelector(selector)) return;
    const task = import(url).catch(error => {
      pending.delete(url);
      console.warn('No se ha podido preparar un control de la tienda', error);
    });
    pending.set(url, task);
  };
  let queued = false;
  const scan = () => { queued = false; for (const [selector, url] of entries) load(selector, url); };
  const observer = new MutationObserver(records => {
    if (queued || !records.some(r => [...r.addedNodes].some(n => n instanceof Element && (n.matches(watched) || n.querySelector(watched))))) return;
    queued = true; queueMicrotask(scan);
  });
  const start = () => { scan(); observer.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  // Retry a failed connection on the customer's next attempt, without changing
  // native click handlers or swallowing their event.
  document.addEventListener('pointerdown', scan, { passive: true, capture: true });
  document.addEventListener('focusin', scan, { passive: true });
})();
